import { createAPIConnection } from 'services';
import { requestHandler } from '../helpers';
import {
	GetCategoriesPhRequest,
	GetCategoriesPhResponse,
	SearchProductsByCategoryPhRequest,
	SearchProductsByCategoryPhResponse,
} from './interfaces';

const api = createAPIConnection('/categories-ph');
const productsApi = createAPIConnection('/products/category-ph');

/**
 * Fetches the complete pharmacy category tree hierarchy for a specific point of sale.
 * Returns a nested structure of categories with their children.
 *
 * @param params - Request parameters
 * @param params.posId - Point of sale identifier
 * @returns Promise resolving to the category tree array
 */
export async function getCategoriesPh({ posId }: GetCategoriesPhRequest) {
	return requestHandler<GetCategoriesPhResponse['content']>(api.get(`/${posId}`));
}

/**
 * Searches for products within a specific pharmacy category with optional filtering.
 * Supports pagination and faceted search for refined results.
 *
 * @param params - Search parameters
 * @param params.posId - Point of sale identifier
 * @param params.categoryPhId - Pharmacy category identifier to search in
 * @param params.page - Page number for pagination (0-indexed)
 * @param params.size - Number of products per page
 * @param params.facets - Optional facet filters (brand, category, industry, etc.)
 * @returns Promise resolving to paginated product results with facets
 */
export async function searchProductsByCategoryPh(props: SearchProductsByCategoryPhRequest) {
	return requestHandler<SearchProductsByCategoryPhResponse>(productsApi.post('/search', { ...props }));
}
